import { DOCUMENT_TYPES } from '@savgroup-front-common/constants';
import { DocumentData } from '@savgroup-front-common/core/formatters/getDocumentNameTranslated';
import { Document } from '@savgroup-front-common/types';

interface AdaptClaimDocumentsToClientDocumentDataArgs {
  documents?: Document[];
}

export const adaptClaimDocumentsToClientDocumentData = ({
  documents,
}: AdaptClaimDocumentsToClientDocumentDataArgs): DocumentData[] => {
  return (documents || [])
    .filter(
      (document) =>
        document.name === DOCUMENT_TYPES.IMAGE ||
        (document.name !== DOCUMENT_TYPES.RETURN_VOUCHER &&
          document.originalFileName &&
          document.customerVisibility),
    )
    .map((document) => ({
      ...document,
      type: DOCUMENT_TYPES.IMAGE,
      documentName:
        document.name === DOCUMENT_TYPES.IMAGE
          ? DOCUMENT_TYPES.IMAGE
          : document.originalFileName || '',
    }));
};
